<template lang="pug">
  div.wrap-item-slide-mindo
    div(:class="{'animation-bound': activeBoundClass}").wrap-icon.f.fc.mb4
      v-icon(size="62px" :color="mindoEmoticon.color") {{mindoEmoticon.icon}}
    span(:style="`color: ${mindoEmoticon.color};`").block.text-center.fz14.mb4 総合民度：{{mindoScore}}
    div.f.fm.fc
      div.f.fm
        span(:style="`color: ${mindoEmoticon.color};`").block.text-center.fz12.mr8 ページ内：{{mindoScoreInPage}}
        span(:style="`color: ${mindoEmoticon.color};`").block.text-center.fz12 個人：{{personalMindoScore}}
    //- span {{mindoEmoticon.icon}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-slide-mindo {
  .wrap-icon {
    &.animation-bound {
      animation-name: doodle-rotate;
      animation-duration: 200ms;
    }
    @keyframes doodle-rotate {
      0% {
        transform: rotateZ(0deg);
      }
      25% {
        transform: rotateZ(-10deg);
      }
      50% {
        transform: rotateZ(0deg);
      }
      75% {
        transform: rotateZ(10deg);
      }
      100% {
        transform: rotateZ(0deg);
      }
    }
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    slide: {
      type: Object,
      required: true
    },
    doodles: {
      type: Array,
      required: true
    },
    userNum: {
      type: Number,
      require: true
    }
  },
  data () {
    return {
      mindoEmoticon: { 
        icon: 'mdi-emoticon-neutral-outline',
        color: '#4ea8de'
      },
      activeBoundClass: false,
      activeBoundClassTimer: null
    }
  },
  watch: {
    mindoScore () {
      // console.log('mindoScore')
      this.mindoEmoticon = this.getIcon()
    },
    // mindoScore: {
    //   handler () {
    //     console.log('mindoScore')
    //     this.mindoEmoticon = this.getIcon()
    //   },
    //   deep: true
    // },
    mindoEmoticon (newIcon, oldIcon) {
      if (newIcon.icon !== oldIcon.icon) {
        
        clearTimeout(this.activeBoundClassTimer)
        this.activeBoundClassTimer = setTimeout(() => {
          this.activeBoundClass = false
        }, 400)
        this.activeBoundClass = true
      }
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    mindoScore () {
      const recentDoodles = this.doodles
      if (!recentDoodles[0]) return 0
      const likeSum = recentDoodles.map(d => d.likeNum)
        .reduce((sum, el) => { return sum + el }, 0)
      const dislikeSum = recentDoodles.map(d => d.dislikeNum)
        .reduce((sum, el) => { return sum + el }, 0)
      return likeSum - dislikeSum
    },
    mindoScoreInPage () {
      const doodlesInPage = this.doodles
        .filter(e => e.page === this.slide.currentPage)
      if (!doodlesInPage[0]) return 0
      const likeSum = doodlesInPage.map(d => d.likeNum)
        .reduce((sum, el) => { return sum + el }, 0)
      const dislikeSum = doodlesInPage.map(d => d.dislikeNum)
        .reduce((sum, el) => { return sum + el }, 0)
      return likeSum - dislikeSum
    },
    personalMindoScore () {
      const myDoodles = this.doodles
        .filter(e => e.createdBy === this.uid)
      if (!myDoodles[0]) return 0
      const likeSum = myDoodles.map(d => d.likeNum)
        .reduce((sum, el) => { return sum + el }, 0)
      const dislikeSum = myDoodles.map(d => d.dislikeNum)
        .reduce((sum, el) => { return sum + el }, 0)
      return likeSum - dislikeSum
    }
  },
  async created () {
    this.mindoEmoticon = this.getIcon()
  },
  methods: {
    getIcon () {
      const baseNum = (this.userNum >= 20) ? this.userNum : 20

      // 民度がマイナスの場合
      if (-baseNum * 0.1 <= this.mindoScore && this.mindoScore < 0) {
        return { 
          icon: 'mdi-emoticon-neutral-outline',
          color: '#ffba08'
        }
      } else if (-baseNum * 0.2 <= this.mindoScore && this.mindoScore < -baseNum * 0.1) {
        return { 
          icon: 'mdi-emoticon-sad-outline',
          color: '#faa307'
        }
      } else if (-baseNum * 0.3 <= this.mindoScore && this.mindoScore < -baseNum * 0.2) {
        return { 
          icon: 'mdi-emoticon-frown-outline',
          color: '#f48c06'
        }
      } else if (-baseNum * 0.4 <= this.mindoScore && this.mindoScore < -baseNum * 0.3) {
        return { 
          icon: 'mdi-emoticon-cry-outline',
          color: '#e85d04'
        }
      } else if (this.mindoScore < -baseNum * 0.4) {
        return { 
          icon: 'mdi-panda',
          color: '#d00000'
        }
      }

      // 民度がプラスの場合
      if (0 <= this.mindoScore && this.mindoScore <= baseNum * 0.1) {
        return {
          icon: 'mdi-emoticon-neutral-outline',
          color: '#4ea8de'
        }
      } else if (baseNum * 0.1 < this.mindoScore && this.mindoScore <= baseNum * 0.2) {
        return {
          icon: 'mdi-emoticon-happy-outline',
          color: '#48bfe3'
        }
      } else if (baseNum * 0.2 < this.mindoScore && this.mindoScore <= baseNum * 0.3) {
        return {
          icon: 'mdi-emoticon-excited-outline',
          color: '#56cfe1'
        }
      } else if (baseNum * 0.3 < this.mindoScore && this.mindoScore <= baseNum * 0.4) {
        return { 
          icon: 'mdi-emoticon-wink-outline',
          color: '#64dfdf'
        }
      } else if (baseNum * 0.4 < this.mindoScore && this.mindoScore <= baseNum * 0.5) {
        return { 
          icon: 'mdi-emoticon-cool-outline',
          color: '#72efdd'
        }
      } else if (baseNum * 0.5 < this.mindoScore) {
        return { 
          icon: 'mdi-star-face',
          color: '#80ffdb'
        }
      }
    }
  }
}
</script>
